import React from "react";
import { JWT } from "../Components/shared";
import { Outlet, Navigate } from "react-router-dom";

const UnAuthenticatedRoutes = () => {
  const isValidToken = JWT.isValidToken();

  return isValidToken === false? (
    <Outlet /> 
  ) : (
    <Navigate to="/dashboard"/>
  );
};

export default UnAuthenticatedRoutes;
